import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MaterialUIControllerProvider } from './context/contexts';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux';
import reduxStore from './stateManagement/reduxStore';
import 'bootstrap/dist/css/bootstrap.min.css';

// styles for this kit
import "./assets/css/bootstrap.min.css";
import "./assets/scss/now-ui-kit.scss?v=1.5.0";
import "./assets/demo/demo.css?v=1.5.0";
import "./assets/demo/nucleo-icons-page-styles.css?v=1.5.0";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <Router>
        <MaterialUIControllerProvider>
          <App />
        </MaterialUIControllerProvider>
      </Router>
    </Provider>
  </React.StrictMode>
);
